<sl-titulo>Registro</sl-titulo>

<opciones-registro-nacimiento [validarIdentificador]="validarIdentificador"></opciones-registro-nacimiento>
